import { uploadImage } from '@/lib/image-upload';

export { ImageUploadError as BrandingUploadError } from '@/lib/image-upload';
export type { ImageUploadErrorCode as BrandingUploadErrorCode } from '@/lib/image-upload';

export async function uploadBrandingImage(
  rawFile: File,
  restaurantId: string,
  kind: 'logo' | 'cover' | 'gallery',
): Promise<{ key: string }> {
  return uploadImage(rawFile, restaurantId, kind);
}
